export default __webpack_public_path__ + "static/media/DarkBlue0005.2680750a.png";